export default "__VITE_ASSET__grkTvhQ6__"